import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { cpf, cnpj } from 'cpf-cnpj-validator';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { SelectButton } from 'primereact/selectbutton';
import { Toast } from 'primereact/toast';

import { useFormCreateNegocio } from 'src/controllers/Negocio/CreateNegocioController';
import LoadingScreen from 'src/components/LoadingScreen';
import { useHistory } from 'react-router-dom';

interface InputMaskProps {
	label: string;
	mask: string;
	placeholder: string;
}

const NegocioForm: React.FC = () => {
	const { getNegocioFormController, handleNegocioFormController } = useFormCreateNegocio();
	const [inputMask, setInputMask] = useState<InputMaskProps>({
		label: 'CNPJ',
		mask: '99.999.999/9999-99',
		placeholder: '__.___.___/____-__',
	});

	const [registerFinished, setRegisterFinished] = useState(false);

	const history = useHistory();


	useEffect(() => {
		if (getNegocioFormController.negocioResponse?.status === 200) {
			setRegisterFinished(true);
		}
		if (
			getNegocioFormController.negocioEditedResponse?.status === 200 &&
			!getNegocioFormController.negocioResponse
		) {
			setRegisterFinished(false);
		}
	}, [getNegocioFormController.negocioResponse, getNegocioFormController.negocioEditedResponse]);


	return (
		<div style={{ height: '100%' }} className='card p-align-center p-justify-center'>
			<Toast ref={getNegocioFormController.toast} />
			<h5>Cadastro de Negocios</h5>
			{getNegocioFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			<form className='p-grid p-fluid'>
				<div className='p-field p-col-12 p-md-4'>
					<label htmlFor='cpf'>CNPJ</label>
					<div className='p-inputgroup'>

						<InputMask
							id='CNPJ'
							maxlength={14}
							autoClear={false}
							mask={inputMask.mask}
							placeholder={inputMask.placeholder}
							{...getNegocioFormController.formik.getFieldProps('CNPJ')}
							onChange={(e) => getNegocioFormController.formik.setFieldValue('CNPJ', e.value)}

						/>
					</div>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getNegocioFormController.formik.touched.CNPJ &&
								getNegocioFormController.formik.errors.CNPJ,
							'popup-form-inactive': !(
								getNegocioFormController.formik.touched.CNPJ &&
								getNegocioFormController.formik.errors.CNPJ
							),

						})}>
					</div>
				</div>

				<div className='p-field p-col-12 p-md-8'>
					<label htmlFor='nomeComp'>Razão Social</label>
					<InputText
						id='RAZAOSOCIAL'
						{...getNegocioFormController.formik.getFieldProps('RAZAOSOCIAL')}
						onChange={getNegocioFormController.formik.handleChange('RAZAOSOCIAL')}

					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getNegocioFormController.formik.touched.RAZAOSOCIAL &&
								getNegocioFormController.formik.errors.RAZAOSOCIAL,
							'popup-form-inactive': !(
								getNegocioFormController.formik.touched.RAZAOSOCIAL &&
								getNegocioFormController.formik.errors.RAZAOSOCIAL
							),
						})}>
						{getNegocioFormController.formik.errors.RAZAOSOCIAL}
					</div>
				</div>

				<div className='p-field p-col-12 p-md-4'>
					<label htmlFor='banco'>ENDEREÇO</label>
					<InputText
						id='ENDERECO'
						maxLength={150}
						disabled={registerFinished}
						{...getNegocioFormController.formik.getFieldProps('ENDERECO')}
						onChange={getNegocioFormController.formik.handleChange('ENDERECO')}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getNegocioFormController.formik.touched.ENDERECO &&
								getNegocioFormController.formik.errors.ENDERECO,
							'popup-form-inactive': !(
								getNegocioFormController.formik.touched.ENDERECO &&
								getNegocioFormController.formik.errors.ENDERECO
							),
						})}>
						{getNegocioFormController.formik.errors.ENDERECO}
					</div>
				</div>

				<div className='p-field p-col-12 p-md-4'>
					<label htmlFor='CEP'>CEP</label>
					<InputText
						id='CEP'
						maxLength={10}
						placeholder='__.___-___'
						disabled={registerFinished}
						{...getNegocioFormController.formik.getFieldProps('CEP')}
						onChange={getNegocioFormController.formik.handleChange('CEP')}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getNegocioFormController.formik.touched.CEP &&
								getNegocioFormController.formik.errors.CEP,
							'popup-form-inactive': !(
								getNegocioFormController.formik.touched.CEP &&
								getNegocioFormController.formik.errors.CEP
							),
						})}>
						{getNegocioFormController.formik.errors.CEP}
					</div>
				</div>

				<div className='p-field p-col-12 p-md-4'>
					<label htmlFor='conta'>BAIRRO</label>
					<InputText
						id='BAIRRO'
						// maxlength={20}
						disabled={registerFinished}
						{...getNegocioFormController.formik.getFieldProps('BAIRRO')}
						onChange={(e) => getNegocioFormController.formik.setFieldValue('BAIRRO', e.currentTarget.value)}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getNegocioFormController.formik.touched.BAIRRO &&
								getNegocioFormController.formik.errors.BAIRRO,
							'popup-form-inactive': !(
								getNegocioFormController.formik.touched.BAIRRO &&
								getNegocioFormController.formik.errors.BAIRRO
							),
						})}>
						{getNegocioFormController.formik.errors.BAIRRO}
					</div>
				</div>
				<div className='p-field p-col-12 p-md-4'>
					<label htmlFor='conta'>MUNICIPIO</label>
					<InputText
						id='MUNICIPIO'
						// maxlength={20}
						disabled={registerFinished}
						{...getNegocioFormController.formik.getFieldProps('MUNICIPIO')}
						onChange={(e) => getNegocioFormController.formik.setFieldValue('MUNICIPIO', e.currentTarget.value)}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getNegocioFormController.formik.touched.MUNICIPIO &&
								getNegocioFormController.formik.errors.MUNICIPIO,
							'popup-form-inactive': !(
								getNegocioFormController.formik.touched.MUNICIPIO &&
								getNegocioFormController.formik.errors.MUNICIPIO
							),
						})}>
						{getNegocioFormController.formik.errors.MUNICIPIO}
					</div>
				</div>

				<div className='p-field p-col-12 p-md-4'>
					<label htmlFor='conta'>EMAIL</label>
					<InputText
						id='EMAIL'
						// maxlength={20}
						disabled={registerFinished}
						{...getNegocioFormController.formik.getFieldProps('EMAIL')}
						onChange={(e) => getNegocioFormController.formik.setFieldValue('EMAIL', e.currentTarget.value)}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getNegocioFormController.formik.touched.EMAIL &&
								getNegocioFormController.formik.errors.EMAIL,
							'popup-form-inactive': !(
								getNegocioFormController.formik.touched.EMAIL &&
								getNegocioFormController.formik.errors.EMAIL
							),
						})}>
						{getNegocioFormController.formik.errors.EMAIL}
					</div>
				</div>



			</form>

			<div className='p-fluid p-grid p-justify-between'>
				{getNegocioFormController.negocioResponse?.status === 200 && !registerFinished ? (
					<div className='p-col-12 p-md-4'>
						<Button
							type='button'
							label='Salvar Alterações'
							onClick={() => {
								getNegocioFormController.formik.handleSubmit();
							}}
						/>
					</div>
				) : getNegocioFormController.negocioResponse?.status === 200 && registerFinished ? (
					<div className='p-col-12 p-md-6 p-fluid p-grid'>
						<div className='p-col-12 p-md-5'>
							<Button
								type='button'
								label='Editar'
								onClick={() => {
									setRegisterFinished(false);
								}}
							/>
						</div>
						<div className='p-col-12 p-md-5'>
							<Button
								icon='pi pi-plus'
								type='button'
								className='p-button-success'
								label='Cadastrar novo'
								onClick={() => {
									getNegocioFormController.formik.resetForm();
									setRegisterFinished(false);
									handleNegocioFormController.setNegocioResponse(null);
								}}
							/>
						</div>
					</div>
				) : (
					<div className='p-col-12 p-md-4'>
						<Button
							type='button'
							label='Cadastrar'
							onClick={() => {
								console.log('values:', getNegocioFormController.formik.values);
								console.log('errors:', getNegocioFormController.formik.errors);
								console.log('isValid:', getNegocioFormController.formik.isValid);
								getNegocioFormController.formik.handleSubmit();
							}}
						/>
					</div>
				)}

				<div className='p-col-12 p-md-6 p-fluid p-grid'>
					<div className='p-col-6'>
						<Button
							type='button'
							label='Limpar'
							onClick={() => {
								getNegocioFormController.formik.resetForm();
							}}
						/>
					</div>
					<div className='p-col-6'>
						<Button
							type='button'
							className='p-button-secondary'
							label='Voltar para listagem'
							onClick={() => history.goBack()}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NegocioForm;
